import { render, staticRenderFns } from "./GiveAndAskCategories.vue?vue&type=template&id=29928a44&"
import script from "./GiveAndAskCategories.vue?vue&type=script&lang=js&"
export * from "./GiveAndAskCategories.vue?vue&type=script&lang=js&"
import style0 from "./GiveAndAskCategories.vue?vue&type=style&index=0&id=29928a44&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports